import { render, staticRenderFns } from "./project-documents-report.vue?vue&type=template&id=cc27889a&scoped=true"
import script from "./project-documents-report.vue?vue&type=script&lang=js"
export * from "./project-documents-report.vue?vue&type=script&lang=js"
import style0 from "./project-documents-report.vue?vue&type=style&index=0&id=cc27889a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc27889a",
  null
  
)

export default component.exports